/**
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export { NzNoAnimationModule } from './nz-no-animation.module';
export { NzNoAnimationDirective } from './nz-no-animation.directive';
